import { V1ExternalAccountInfo } from '@blk/portfolio-security-server/accountInfo';
import { PasAsset } from '@ddt-web/pas';

import { AccountErrors, PartnerAccount, PartnerPlatform } from '../../models';


export class ImportPartnerPortfoliosState {
	public partnerPlatform?: PartnerPlatform = null;
	public selectedPortfolios?: Map<string, V1ExternalAccountInfo> = new Map();
	public portfolioData?: PartnerAccount[] = [];
	public resolvedAssets?: Map<string, Partial<PasAsset>> = new Map();
	public accountErrorMap?: Map<string, AccountErrors> = new Map();
	public isRefreshNeeded?: boolean = false;
}
